import { set } from '@/utils/vuex';

export default {
  setWorkshop: set('workshop'),
  setWorkshopIcon: set('icon'),
};
